module.exports = __webpack_public_path__ + "img/caohuijun.8c8cf659.jpg";